import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import ChannelsTable from "./ChannelsTable";
import ChannelsDeleteModal from "./ChannelsDeleteModal";
import ChannelsDrawer from "./ChannelsDrawer";
import ChannelsHeader from "./ChannelsHeader";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

function ChannelsPage() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const navigate = useNavigate();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);
	const { theme } = useSelector((state: RootState) => state.home);
	const { server } = useSelector((state: RootState) => state.server);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */0

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		if (!server) {
			navigate("/edge-management/servers");
		}
	}, []);
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{validatePermission("view-edge-management-channels", permissions) ? (
				<div className={`layout__contentPage__${theme}`}>
					<ChannelsHeader />
					<ChannelsTable />
					<ChannelsDeleteModal />
					<ChannelsDrawer />
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</div>
	);
}

export default ChannelsPage;
